import proj4 from "proj4";

export class ProjectionsRegistrar {
    public static RegisterEPSG27700() {
        const name = this.GetEPSG27700Name();
        const definition = this.GetEPSG27700Definition();
        this.RegisterProjection(name, definition);
    }
    public static RegisterEastingNorthing() {
        this.RegisterProjection(this.EastingNorthingName, this.EastingNorthingDefinition);
    }

    public static RegisterProjection(projName: string, projDefinition: string) {
        proj4.defs(projName, projDefinition);
    }

    public static GetEPSG27700Definition(): string {
        return "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs";
    }
    public static GetEPSG27700Name() {
        return "EPSG:27700";
    }
    public static get EastingNorthingDefinition(): string {
        return "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +datum=OSGB36 +units=m +no_defs";
    }
    public static get EastingNorthingName() {
        return "EastingNorthing";
    }
}
